import React, { useState, useEffect } from "react";
import "../../Styles/Integration.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

export default function SwitchExample() {
  const [isLoading, setIsLoading] = useState(false);
  
  // 1. Internal State
  const [settingsData, setSettingsData] = useState({
    merchant_id: "",
    publickey: "",
    privatekey: "",
    accountid: "",
    gateway_type: "razorpay",
    transaction_charge: 0,

    online_payment: 0,
    cashless: 0,
    gateway_status: 0,
    settings_sms_gateway_status: 0,

    max_balance_limit: 0,
    min_balance_limit: 0,
    max_transaction: 0,

    gateway_username: "",
    gateway_password: "",
    gateway_sender_id: ""
  });

  useEffect(() => {
    fetchIntegrationSettings();
  }, []);

  // 2. Fetch API data and map from the new JSON structure
  const fetchIntegrationSettings = async () => {
    setIsLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key")
    };

    try {
      const response = await simplePostCall(
        ApiConfig.parentintegrationsettingsget,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        const settings = response.settingsModel?.[0] || {};
        const gateway = response.gatewaymodel?.[0] || {};
        const sms = response.smsgatewayModel?.[0] || {};

        setSettingsData({
          // Map from settingsModel
          online_payment: Number(settings.settings_online_payment) || 0,
          cashless: settings.settings_cashless || 0,
          max_balance_limit: settings.settings_maximum_balance_limit || 0,
          min_balance_limit: settings.settings_minimum_balance_limit || 0,
          max_transaction: settings.settings_max_transactions || 0,
          settings_sms_gateway_status: settings.settings_sms_gateway_status || 0,
          gateway_type: settings.settings_payment_gateway || "razorpay",

          // Map from gatewaymodel
          merchant_id: gateway.payment_gateway_merchant_id || "",
          publickey: gateway.payment_gateway_publickey || "",
          privatekey: gateway.payment_gateway_privatekey || "",
          accountid: gateway.payment_gateway_accountid || "",
          transaction_charge: Number(gateway.paymant_gateway_transaction_charge) || 0,

          // Map from smsgatewayModel
          gateway_username: sms.sms_gateway_username || "",
          gateway_password: sms.sms_gateway_password || "",
          gateway_sender_id: sms.sms_gateway_sender_id || ""
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // 3. Save settings
  const handleUpdateSettings = async () => {
    setIsLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),

      PaymantGatewayOptions: {
        merchant_id: settingsData.merchant_id,
        publickey: settingsData.publickey,
        privatekey: settingsData.privatekey,
        accountid: settingsData.accountid,
        gateway_type: settingsData.gateway_type,
        transaction_charge: settingsData.transaction_charge
      },

      settings: {
        online_payment: settingsData.online_payment,
        cashless: settingsData.cashless,
        max_balance_limit: settingsData.max_balance_limit,
        min_balance_limit: settingsData.min_balance_limit,
        gateway_status: settingsData.gateway_status,
        settings_sms_gateway_status: settingsData.settings_sms_gateway_status
      },

      smsgateway: {
        gateway_username: settingsData.gateway_username,
        gateway_password: settingsData.gateway_password,
        gateway_sender_id: settingsData.gateway_sender_id
      }
    };

    try {
      const response = await simplePostCall(
        ApiConfig.integrationsettings,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        toast.success("Settings updated successfully!");
      }  else {
      toast.error("Failed to update settings");
    }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  // 4. Handle input change
  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;

    setSettingsData(prev => ({
      ...prev,
      [id]: type === "checkbox" ? (checked ? 1 : 0) : value
    }));
  };

  return (
    <> 
     
      <div className="special-header bg-white d-flex justify-content-between align-items-center mt-4 mb-4 p-2">
      {/* <ToastContainer/> */}
       <ToastContainer/>
        <h4 className="ms-4 mt-2 fw-bold">Integration Settings</h4>
        <button
          onClick={handleUpdateSettings}
          className="btn custom-btn me-3"
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Save changes"}
        </button>
      </div>

      <div className={`card integra-back p-4 ${isLoading ? "opacity-50" : ""}`}>

        {/* Payment Settings */}
        <div className="border p-3 mb-4 rounded">
          <h6>Payment Settings</h6>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="online_payment"
              checked={settingsData.online_payment === 1}
              onChange={handleChange}
            />
            <label className="form-check-label">
              {settingsData.online_payment === 1
                ? "Online Payment Active"
                : "Activate Online Payment"}
            </label>
          </div>

          {settingsData.online_payment === 1 && (
            <div className="row">
              <div className="col-md-6 mb-2">
                <label>Payment Gateway</label>
                <select
                  className="form-select"
                  id="gateway_type"
                  value={settingsData.gateway_type}
                  onChange={handleChange}
                >
                  <option value="razorpay">RazorPay</option>
                  <option value="mpesa">M-Pesa</option>
                  <option value="paypal">PayPal</option>
                </select>
              </div>

              <div className="col-md-6 mb-2">
                <label>Merchant ID</label>
                <input
                  type="text"
                  className="form-control"
                  id="merchant_id"
                  value={settingsData.merchant_id}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-2">
                <label>Public Key</label>
                <input
                  type="text"
                  className="form-control"
                  id="publickey"
                  value={settingsData.publickey}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-2">
                <label>Private Key</label>
                <input
                  type="text"
                  className="form-control"
                  id="privatekey"
                  value={settingsData.privatekey}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>

        {/* Cashless Settings */}
        <div className="border p-3 mb-4 rounded">
          <h6>Cashless Settings</h6>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="cashless"
              checked={settingsData.cashless === 1}
              onChange={handleChange}
            />
            <label className="form-check-label">
              Cashless Enabled: {settingsData.cashless === 1 ? "YES" : "NO"}
            </label>
          </div>

          {settingsData.cashless === 1 && (
            <div className="row">
              <div className="col-md-6 mb-2">
                <label>Max Balance</label>
                <input
                  type="number"
                  className="form-control"
                  id="max_balance_limit"
                  value={settingsData.max_balance_limit}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-2">
                <label>Min Balance</label>
                <input
                  type="number"
                  className="form-control"
                  id="min_balance_limit"
                  value={settingsData.min_balance_limit}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>

        {/* SMS Gateway */}
        <div className="border p-3 mb-4 rounded">
          <h6>SMS Gateway</h6>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="settings_sms_gateway_status"
              checked={settingsData.settings_sms_gateway_status === 1}
              onChange={handleChange}
            />
            <label className="form-check-label">SMS Status</label>
          </div>

          {settingsData.settings_sms_gateway_status === 1 && (
            <div className="row">
              <div className="col-md-4 mb-2">
                <label>Username</label>
                <input
                  type="text"
                  className="form-control"
                  id="gateway_username"
                  value={settingsData.gateway_username}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4 mb-2">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="gateway_password"
                  value={settingsData.gateway_password}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4 mb-2">
                <label>Sender ID</label>
                <input
                  type="text"
                  className="form-control"
                  id="gateway_sender_id"
                  value={settingsData.gateway_sender_id}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}